import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';
import { AntEnvService, AuthService, AbsAuthService, HelperService } from '../../_services';
import { DataServiceProvider } from 'src/app/_providers';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers:[{provide: AbsAuthService, useClass: AuthService}]
})
export class HomeComponent implements OnInit {
  cards = [
    //{title: 'Dashboard', title2: 'Analytic Dashboard', cssCard: 'gradient-shadow gradient-45deg-light-blue-cyan', cssIcon: 'gradient-45deg-red-pink', route: 'dashboard', icon: 'equalizer'},
    //{title: 'DASHBOARD', title2: 'Analytic Dashboard', cssCard: 'gradient-shadow gradient-45deg-amber-amber', cssIcon: 'gradient-45deg-red-pink', route: '', icon: 'equalizer'},
    //{title: 'Export Data', title2: 'Export Data from System', cssCard: 'gradient-45deg-deep-orange-orange gradient-shadow', cssIcon: 'gradient-45deg-red-pink', route: 'dashboard', icon: 'trending_down'},
    //{title: 'Import Data', title2: 'Import Data to System', cssCard: 'gradient-45deg-purple-deep-orange gradient-shadow', cssIcon: 'gradient-45deg-red-pink', route: '', icon: 'trending_up'},
    //{title: 'Settings', title2: 'Analytic Dashboard', cssCard: 'red', cssIcon: 'gradient-45deg-red-pink', route: 'settings', icon: 'settings'},
    //{title: 'Users', title2: 'System User Management', cssCard: 'gradient-shadow gradient-45deg-green-teal', cssIcon: 'gradient-45deg-red-pink', route: 'users', icon: 'people_outline'},
    //{title: 'Logs', title2: 'System Logs', cssCard: 'blue-grey darken-4', cssIcon: 'gradient-45deg-red-pink', route: '', icon: 'chrome_reader_mode'},
  ]
  constructor(
    private router: Router,
    private http: HttpClient,
    private changeDetector : ChangeDetectorRef,
    private firebaseAuth: AngularFireAuth,
    private svcAntEnv: AntEnvService,
    private svcHelper: HelperService,
    private svcAuth: AbsAuthService,
  ) { 
    this.svcAuth = DataServiceProvider.useFactory(this.firebaseAuth, this.http, this.svcAntEnv);
  }

  ngOnInit() {
    // var currentAcc = this.svcAuth.getCurrentUser();
    // this.cards = this.svcHelper.menus(currentAcc);
    this.menuListLoad();
  }
  ngAfterViewInit(){
    var elems = document.querySelectorAll('.collapsible');
    let instanceCollapsible = M.Collapsible.init(elems, {});
    this.changeDetector.detectChanges();
  }
  menuListLoad(){
    //console.log('menu-list-load');
    setTimeout(()=>{
      this.cards = this.svcHelper.menuList;
      if(this.cards.length<1) this.menuListLoad();
    }, 500);
  }
  goto = function(argRout){
    //console.log(argRout);
    this.router.navigate([argRout]);
  }
}
